import { useCallback, useEffect, useState } from "react";
import { useModel } from "@@/exports";
import {
  postBaobSettingPcSupplyConfig,
  PostBaobSettingPcSupplyConfig200Data,
} from "@/openapi/baob/SettingPc/api.client.axios";

interface SupplyStateType {
  error: unknown | undefined | Error;
  supplyConfig: PostBaobSettingPcSupplyConfig200Data | undefined;
}

const initState: SupplyStateType = {
  supplyConfig: undefined,
  error: undefined,
};

export default () => {
  const { initialState } = useModel("@@initialState");
  const [state, setState] = useState(initState);
  const getSupplyConfig = useCallback(async () => {
    try {
      const res = await postBaobSettingPcSupplyConfig({});
      setState((s) => ({ ...s, supplyConfig: res.data }));
    } catch (e) {
      setState((s) => ({ ...s, error: e, supplyConfig: undefined }));
    }
  }, []);

  useEffect(() => {
    getSupplyConfig();
  }, [getSupplyConfig, initialState?.currentUser]);

  return {
    ...state,
    getSupplyConfig,
  };
};
